import { render, staticRenderFns } from "./PeopleTourRewardsProduct.vue?vue&type=template&id=aa82b7fa"
import script from "./PeopleTourRewardsProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./PeopleTourRewardsProduct.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports